document.addEventListener('alpine:init', () => {
  Alpine.data('FAQList', () => ({
    init() {
      setTimeout(this.InitSelf.bind(this), 250);
    },
    InitSelf() {
      let am = this;
      let is_mobile = window.matchMedia('(max-width: 769px)').matches;
      if (is_mobile) {
        window.scrollTo({
          top: am.$el.offsetTop - 100
        })
      }
    }
  }));

  Alpine.data('CustomPaletteTopSelection', () => ({
    selected: '',
    init() {
      this.InitSelf();
      this.InitWatchers()
    },
    InitSelf() {
      let am = this;
      am.selected = am.$el.dataset.selected;
    },
    InitWatchers() {
      let am = this;
      am.$watch('selected', () => {
        // console.log(am.selected)
        let $form = document.querySelector('#AddToCartForm');
        if (!$form) return;
        let $input = $form.querySelector(`input[value="${am.selected}"]`);
        $input.checked = true;
        $input.dispatchEvent(new Event('change', {bubbles: true}));
        $input.dispatchEvent(new Event('click', {bubbles: true}))
      })
    }
  }));
});